export default __webpack_public_path__ + "static/media/header.c5fbf1fc.png";